import _ from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import { List, ListItem } from "../../../../components/list";
import { punyToUnicode } from "../../../../utils/punyToUnicode";
import { useIntlTranslate } from "../../../../hooks";

export const UrlList = ({
  icon,
  nameKey,
  items,
  onItemRemove,
  onClear,
  className,
}) => {
  const translate = useIntlTranslate();
  const name = translate(nameKey);

  return (
    <List
      className={classnames("url-list", className)}
      title={name}
      clearText={<FormattedMessage id="remove_all" />}
      onClear={onClear}
      placeholder={<FormattedMessage id="no_urls" />}
    >
      {_.map(items, (item) => (
        <ListItem
          item={item}
          icon={icon}
          key={item}
          onRemove={onItemRemove}
          name={name}
        >
          <span className="url-list-item__content">{punyToUnicode(item)}</span>
        </ListItem>
      ))}
    </List>
  );
};
